import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { FormControl, TextField, Checkbox, FormControlLabel, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
interface Filter {
    onCustCodeChange: Function;
    onCommentChange: Function;
    onCommentCheckChange: Function;
    onDateChange: Function;
    onContactBackChange: Function;
    onRatingChange: Function;
}

export default function ResultFilter({ onCustCodeChange, onCommentChange, onCommentCheckChange, onDateChange, onContactBackChange, onRatingChange }: Filter) {
    let _from = new Date();
    _from.setHours(0);
    _from.setMinutes(0);
    _from.setSeconds(0);
    let _to = new Date();
    _to.setHours(23);
    _to.setMinutes(59);
    _to.setSeconds(59);
    const [custCode, setCustCode] = useState('');
    const [comment, setComment] = useState('');
    const [commentCheck, setCommentCheck] = useState(true);
    const [fromDate, setFromDate] = useState<Date | null>(_from);
    const [toDate, setToDate] = useState<Date | null>(_to);
    const [contactBack, setContactBack] = useState<boolean>(false);
    const [rating, setRating] = useState<string>('all');

    const handleCustCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCustCode(e.target.value);
        onCustCodeChange(e.target.value);
    }

    const handleCommentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setComment(e.target.value);
        onCommentChange(e.target.value);
    }

    const handleCommentCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCommentCheck(e.target.checked);
        onCommentCheckChange(e.target.checked);
    }

    const handleFromDateChange = (date: Date | null) => {
        setFromDate(date);
        if (date && toDate && (date.getTime() > toDate.getTime())) {
            setToDate(date);
            onDateChange(date, date);
        } else {
            onDateChange(date, toDate);
        }
    }

    const handleToDateChange = (date: Date | null) => {
        setToDate(date);
        onDateChange(fromDate, date);
    }

    const handleContactBackChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setContactBack(e.target.checked);
        onContactBackChange(e.target.checked);
    }

    const handleRatingChange = (e: SelectChangeEvent) => {
        setRating(e.target.value as string);
        onRatingChange(e.target.value as string)
    }

    return (
        <Container className="filter-container">
            <Row className='filter-row'>
                <Col lg="4">
                    <FormControl fullWidth>
                        <TextField label="Cust Code or BCust Code" variant="outlined" value={custCode} onChange={handleCustCodeChange} />
                    </FormControl>
                </Col>
                <Col lg="4">
                    <FormControl fullWidth>
                        <TextField label="Comment" variant="outlined" value={comment} onChange={handleCommentChange} />
                    </FormControl>
                </Col>
                <Col lg="2">
                    <FormControl fullWidth>
                        <FormControl fullWidth>
                            <InputLabel id="filter-rating-label">Rating</InputLabel>
                            <Select
                                labelId="filter-star-label"
                                value={rating}
                                label="Rating"
                                onChange={handleRatingChange}
                            >
                                <MenuItem value={'all'}>All</MenuItem>
                                <MenuItem value={'0'}>0</MenuItem>
                                <MenuItem value={'1'}>1</MenuItem>
                                <MenuItem value={'2'}>2</MenuItem>
                                <MenuItem value={'3'}>3</MenuItem>
                                <MenuItem value={'4'}>4</MenuItem>
                                <MenuItem value={'5'}>5</MenuItem>
                            </Select>
                        </FormControl>
                    </FormControl>
                </Col>
            </Row>
            <Row className='filter-row'>
                <Col lg="4">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateTimePicker
                            renderInput={(props) => <FormControl fullWidth><TextField {...props} /></FormControl>}
                            label="From"
                            value={fromDate}
                            onChange={handleFromDateChange}
                            inputFormat="dd/MM/yyyy hh:mm aa"
                        />
                    </LocalizationProvider>
                </Col>
                <Col lg="4">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DateTimePicker
                            renderInput={(props) => <FormControl fullWidth><TextField {...props} /></FormControl>}
                            label="To"
                            value={toDate}
                            onChange={handleToDateChange}
                            inputFormat="dd/MM/yyyy hh:mm aa"
                        />
                    </LocalizationProvider>
                </Col>
                <Col lg="2">
                    <FormControlLabel control={<Checkbox checked={commentCheck} onChange={handleCommentCheckChange} />} label="Commented" />
                </Col>
                <Col lg="2">
                    <FormControlLabel control={<Checkbox checked={contactBack} onChange={handleContactBackChange} />} label="Contact Back" />
                </Col>
            </Row>
        </Container>
    )
}